import React, { useCallback, useEffect, useState } from "react";
import { Input, Table } from "antd";
import axios from "axios";
// import { UserInfo } from "../../../context";

const columns = [
  {
    title: "SKU",
    dataIndex: "sku",
    sorter: (a, b) => a.sku - b.sku,
    render: (text, record) => <p>{text}</p>,
  },
  {
    title: "Product",
    dataIndex: "product",
    render: (text, record) => <p>{text}</p>,
  },
  {
    title: "Description",
    dataIndex: "description",
    render: (text, record) => <p>{text}</p>,
  },
  {
    title: "Unit",
    dataIndex: ["rawproductsuserunit", "unit"],
    filters: [
      {
        text: "Piece(s)",
        value: "Piece(s)",
      },
      {
        text: "Bottle(s)",
        value: "Bottle(s)",
      },
      {
        text: "Vial(s)",
        value: "Vial(s)",
      },
      {
        text: "Box(s)",
        value: "Box(s)",
      },
    ],
    onFilter: (value, record) =>
      record.rawproductsuserunit.unit.includes(value),
    ellipsis: true,
    render: (text, record) => <p>{text}</p>,
  },
  {
    title: "MSRP",
    dataIndex: "msrp",
    align: "right",
    render: (text, record) => <p>{text}</p>,
  },
  {
    title: "SRP",
    dataIndex: "srp",
    align: "right",
    render: (text, record) => <p>{text}</p>,
  },
  {
    title: "Quantity",
    dataIndex: "quantity",
    align: "right",
    render: (text, record) => <p>{text}</p>,
  },
];

const MerchantDetailsInventory = ({ merchant_id, merchant_user_id }) => {
  const [search, setSearch] = useState("");

  const [productRawList, setProductRawList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};

  const tableProps = {
    bordered: false,
    // loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getRawProductList = useCallback(() => {
    var params = { user_id: merchant_user_id };
    axios
      .get("user/commissary/spec-merchant/raw-product-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setProductRawList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [merchant_user_id]);

  useEffect(() => {
    getRawProductList();
  }, [getRawProductList]);

  const searchable = productRawList.data.filter((data) => {
    return data.product.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  return (
    <div style={{ overflowX: "auto" }}>
      <div style={{ marginBottom: 10 }}>
        <Input
          placeholder="Search raw"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            border: "2px solid #e5e5e5",
            width: window.innerWidth < 576 ? "100%" : 300,
          }}
          size="large"
        />
      </div>

      <Table
        {...tableProps}
        pagination={{
          position: ["bottomCenter"],
        }}
        columns={tableColumns}
        dataSource={searchable.length > 0 ? searchable : []}
        scroll={scroll}
        rowKey={(record) => record.id}
      />
    </div>
  );
};

export default MerchantDetailsInventory;
